import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Fragment } from "react";

import { AppLocationRenderFunction } from "../helpers/faq";
import { CRMAppLocationIdentifier } from "../types/Faq";

export type APDetailListItem = {
  label: string;
  value: string;
  appLocationIdentifier?: CRMAppLocationIdentifier;
  itemAction?: React.ReactNode;
};

const APDetailList = ({
  items,
  boldLabels = true,
  renderAppLocation,
}: {
  items: APDetailListItem[];
  boldLabels?: boolean;
  renderAppLocation?: AppLocationRenderFunction;
}) => {
  const renderLabel = (item: APDetailListItem) => {
    return (
      <Typography
        variant="titleMedium"
        sx={{
          fontWeight: boldLabels ? "bold" : undefined,
          minWidth: 0,
        }}
      >
        {item.label}:
      </Typography>
    );
  };

  const renderValue = (item: APDetailListItem) => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          rowGap: 1,
          alignItems: "flex-start",
        }}
      >
        <Typography variant="titleMedium" sx={{ minWidth: 0 }}>
          {item.value}
        </Typography>

        {item.itemAction}
      </Box>
    );
  };

  const renderItem = (item: APDetailListItem, index: number) => {
    return (
      <Fragment key={index}>
        {item.appLocationIdentifier && renderAppLocation
          ? renderAppLocation(item.appLocationIdentifier, renderLabel(item))
          : renderLabel(item)}
        {item.appLocationIdentifier && renderAppLocation
          ? renderAppLocation(item.appLocationIdentifier, renderValue(item))
          : renderValue(item)}
      </Fragment>
    );
  };

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "fit-content(60%) minmax(0, 1fr)",
        columnGap: 2,
        alignItems: "start",
        rowGap: 0.25,
      }}
    >
      {items.map((item, index) => renderItem(item, index))}
    </Box>
  );
};

export default APDetailList;
